<div class="flex w-full items-center justify-between h-[56px] border-b border-proffeo-overlay-subtle">
  <div class="flex gap-1 items-center">
    @if (childrenVisible) {
      <mat-icon
        fontIcon="keyboard_arrow_up"
        click
        toggleChildren
        class="cursor-pointer icon-xl icon-muted"
      />
    }

    @if (!childrenVisible) {
      <mat-icon
        fontIcon="keyboard_arrow_down"
        click
        toggleChildren
        class="cursor-pointer icon-xl icon-muted"
      />
    }
    <mat-icon
      fontIcon="pin_drop"
      class="materials-symbols-outlined icon-muted"
    />
    <p class="truncate max-sm:max-w-30 max-sm:text-xs">
      {{ dangerousSituation()?.possibleThreat?.value }}
    </p>
  </div>
</div>
@if (childrenVisible) {
  <div class="pl-8 w-full">
    <div class="w-full flex gap-2 items-start">
      <div class="w-full">
        <div class="flex w-full items-center justify-between h-[56px] border-b border-proffeo-overlay-subtle">
          <div class="flex gap-5 justify-between items-center w-[50%]">
            <p class="truncate max-sm:max-w-30 max-sm:text-xs w-[30%]">
              Probability:
              <span class="font-bold">{{ setProbabilityLabel(dangerousSituation().probability) | translate }}</span>
              ,
            </p>
            <p class="truncate max-sm:max-w-30 max-sm:text-xs">
              Consequence:
              <span class="font-bold">{{ setConsequencesLabel(dangerousSituation().consequences) | translate }}</span>
              ,
            </p>
            <p class="truncate max-sm:max-w-30 max-sm:text-xs">
              Risk Level:
              <span class="font-bold">{{ dangerousSituation().riskLevel }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pl-8 w-full">
    <div class="w-full flex gap-2 items-start">
      <div class="w-full">
        <div class="flex w-full items-center justify-between h-[56px] border-b border-proffeo-overlay-subtle">
          <div class="flex gap-5 justify-between items-center w-[50%]">
            <p class="truncate max-sm:max-w-30 max-sm:text-xs w-[30%]">
              Probability:
              <span class="font-bold">
                {{ setProbabilityLabel(dangerousSituation().secondaryProbability) | translate }}
              </span>
              ,
            </p>
            <p class="truncate max-sm:max-w-30 max-sm:text-xs">
              Consequence:
              <span class="font-bold">
                {{ setConsequencesLabel(dangerousSituation().secondaryConsequences) | translate }}
              </span>
              ,
            </p>
            <p class="truncate max-sm:max-w-30 max-sm:text-xs">
              Risk Level:
              <span class="font-bold">{{ dangerousSituation().secondaryRiskLevel }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
